module.exports = __webpack_public_path__ + "img/56.606af08e.jpg";